/**
 * WorkshopDayDrawerHeader — the day drawer's title bar: the date, how many
 * workshops are in view under the current region scope, and the close control.
 *
 * Its own file per the house rule of one component per file; it was extracted
 * from `WorkshopDayDrawer` when that file was touched to share its focus trap.
 */
import { format } from 'date-fns';
import { X } from 'lucide-react';

function workshopCountLabel(count: number): string {
  return count === 1 ? '1 workshop' : `${count} workshops`;
}

export function WorkshopDayDrawerHeader({
  day,
  count,
  regionScopeLabel,
  titleId,
  onClose,
}: {
  day: Date;
  count: number;
  regionScopeLabel: string;
  /** Ties the drawer's `aria-labelledby` to this heading. */
  titleId: string;
  onClose: () => void;
}) {
  return (
    <div className="flex items-start justify-between gap-3 border-b border-stone-200 px-5 py-4 dark:border-stone-700">
      <div>
        <h3
          id={titleId}
          className="text-sm font-bold uppercase tracking-wide text-bark-900 dark:text-stone-100"
        >
          {format(day, 'EEE MMMM d').toUpperCase()}
        </h3>
        <p className="mt-0.5 text-xs text-stone-500 dark:text-stone-400">
          {workshopCountLabel(count)} &middot; {regionScopeLabel} in view
        </p>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        className="flex-shrink-0 rounded-lg p-1.5 text-stone-400 hover:bg-stone-100 hover:text-stone-600 dark:hover:bg-[#252b26]"
      >
        <X size={18} />
      </button>
    </div>
  );
}
